import { createFileRoute, redirect } from '@tanstack/react-router';
import { getDefaultStore } from 'jotai';
import z from 'zod';
import { bidComparisonSheetsQuery } from '@/features/bid-comparison/queries';
import { lastSelectedSheetIdAtom } from '@/features/bid-comparison/store';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/_layout/comparison/',
)({
  validateSearch: z.object({
    commentEntityId: z.string().optional(),
    commentId: z.string().optional(),
  }),
  beforeLoad: async ({ context, params }) => {
    const { projectId, workspaceId } = params;
    const sheets = await context.queryClient.query({
      ...bidComparisonSheetsQuery(workspaceId),
      staleTime: 'static',
    });
    if (sheets.length === 0)
      throw redirect({
        to: '/project/$projectId/workspaces/$workspaceId/bids',
        params: { projectId, workspaceId },
        replace: true,
      });
    const lastSelectedSheetId = getDefaultStore().get(lastSelectedSheetIdAtom(params));
    const sheetId = sheets.find((s) => s.id === lastSelectedSheetId)?.id ?? sheets[0]!.id;
    throw redirect({
      to: '/project/$projectId/workspaces/$workspaceId/bids/comparison/$sheetId',
      params: { projectId, workspaceId, sheetId },
      search: true,
      replace: true,
    });
  },
});
